import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/plemenske_vrednosti";

export const fetchBreedingValue = createAsyncThunk(
  "pv/zival-id",
  async ({ id, kodaPV = "PRIRAST" }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/forZival/${id}?kodaPv=${kodaPV}`
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const breedingValueSlice = createSlice({
  name: "breedingValues",
  initialState: {
    error: null,
    isLoading: false,
    page: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBreedingValue.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchBreedingValue.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchBreedingValue.pending, (state, _action) => {
        state.isLoading = true;
        state.error = null;
      });
  },
});

export default breedingValueSlice.reducer;
